var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M47 2H53V26H47z",
    opacity: 0.501
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M47 74H53V98H47z",
    opacity: 0.901
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M83 38L89 38 89 62 83 62z",
    opacity: 0.696,
    transform: "rotate(90 86 50)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11 38L17 38 17 62 11 62z",
    opacity: 0.098,
    transform: "rotate(90 14 50)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M72.456 63.456H78.456V87.456H72.456z",
    opacity: 0.804,
    transform: "rotate(135 75.456 75.456)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.544 12.544H27.544V36.544H21.544z",
    opacity: 0.155,
    transform: "rotate(135 24.544 24.544)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6702",
    d: "M21.544 63.456H27.544V87.456H21.544z",
    transform: "rotate(-135 24.544 75.456)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M72.456 12.544H78.456V36.544H72.456z",
    opacity: 0.603,
    transform: "rotate(-135 75.456 24.544)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.3c8786e3.svg";
export { ForwardRef as ReactComponent };